import React from 'react';
import Responsive from 'react-responsive';

const Desktop = props => <Responsive {...props} minWidth={992} />;
const LargeMobile = props => <Responsive {...props} maxWidth={992} />;
const Tablet = props => <Responsive {...props} minWidth={768} maxWidth={991} />;
const Mobile = props => <Responsive {...props} maxWidth={767} />;
const MobileAndTablet = props => <Responsive {...props} maxWidth={991} />;
const DesktopAndTablet = props => <Responsive {...props} minWidth={768} />;

module.exports = {
  Desktop,
  LargeMobile,
  Tablet,
  Mobile,
  MobileAndTablet,
  DesktopAndTablet,
};



// WEBPACK FOOTER //
// ./src-react/Responsive/index.jsx